import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import './BcpMap.css';

// ブラウザが位置情報 API 自体を持たない場合に使う独自コード。
// GeolocationPositionError.code は 1〜3 のため 0 と衝突しない。
export const GPS_UNSUPPORTED = 0;

const BCPEmployee = () => {
  const navigate = useNavigate();
  const [loadingGps, setLoadingGps] = React.useState(false);

  // 🌤️ 防災気象情報：GPSで現在地を取得して遷移。
  // 自宅にいれば自宅の情報のみ、外にいれば自宅＋現在地の情報を表示（サーバが自宅判定）。
  const handleWeatherClick = () => {
    if (navigator.geolocation) {
      setLoadingGps(true);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingGps(false);
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // 気象情報ページに緯度経度を渡して遷移
          navigate('/bcp/weather-info', { state: { lat, lng } });
        },
        (error) => {
          setLoadingGps(false);
          // 失敗の理由を画面へ渡す。ここを握り潰すと社員には「取得できませんでした」としか
          // 表示されず、ブラウザの権限が「許可しない」でも本人が気付けない（S0002 の事例）。
          console.warn('[BCP] 位置情報の取得に失敗:', error.code, error.message);
          navigate('/bcp/weather-info', {
            state: { lat: null, lng: null, gpsErrorCode: error.code },
          });
        },
        // 打刻画面（EmployeeTime.js）と条件を揃える。timeout には権限ダイアログの表示時間も
        // 含まれるため、5秒では社員が「許可」をタップする前にタイムアウトしていた。
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
      );
    } else {
      // GPSがサポートされていない場合は、緯度経度なしで遷移
      navigate('/bcp/weather-info', {
        state: { lat: null, lng: null, gpsErrorCode: GPS_UNSUPPORTED },
      });
    }
  };

  return (
    <div className="bcp-page bcp-menu-page">
      <header className="bcp-menu-header">
        <h1 className="bcp-menu-title">BCP 避難所検索</h1>
        <p className="bcp-menu-desc">登録住所または現在地から、最寄りの避難所を検索します。</p>
      </header>
      <div className="bcp-menu-actions">
        <div className="bcp-btn-group">
          <Link className="bcp-btn-home" to="/bcp/home-shelter">
            🏠 登録住所から探す
          </Link>

          <Link className="bcp-btn-nearby" to="/bcp/nearby-shelter">
            📍 現在地から探す
          </Link>

          <Link className="bcp-btn-nearby" to="/bcp/search-address" style={{ backgroundColor: "#e0f2fe", color: "#0369a1", border: "1px solid #bae6fd" }}>
            🔍 任意の住所から探す
          </Link>

          <button type="button" className="bcp-btn-weather" onClick={handleWeatherClick} disabled={loadingGps}>
             {loadingGps ? '⌛ 位置情報を取得中...' : '🌤️ 防災気象情報'}
          </button>
          
          <button type="button" className="bcp-btn-menu-back" onClick={() => navigate('/card_back')}>
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BCPEmployee;
